import React, { Component } from "react";
import {
  getCouponDetailListRequest,
  updateCouponDetailStatusByCouponDetailIdRequest,
  deleteCouponDetailByCouponDetailIdRequest,
} from "store/actions";
import moment from "moment";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeCouponDetailSelectField } from "store/CouponDetail/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import { confirmBox } from "helpers/messageHelper";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";
import {
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Coupon Name",
    field: "couponName",
  },
  {
    label: "Coupon Code",
    field: "couponCode",
  },
  {
    label: "Start Date",
    field: "startDate",
  },
  {
    label: "End Date",
    field: "endDate",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class CouponList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponRecords: [],
      filterDropdownOpen: false,
      filter: {
        active: true,
        inactive: false,
        expired: false,
      },
      filterChanged: false,
    };
  }

  componentDidMount() {
    //Retrieve coupon list
    this.props.getCouponDetailListRequest();
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateCouponDetailStatusByCouponDetailIdRequest(id, checked);
  };

  buildCouponDataTable = (records) => {
    this.setState({
      couponRecords: records.map((coupon) => {
        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-edit fa-lg"
              onClick={this.viewCoupon(coupon)}
              tooltip={"Edit"}
            />

            <CircularIconButton
              icon="far fa-trash-alt fa-lg"
              onClick={this.deleteCoupon(coupon.couponDetailId)}
              tooltip={"Delete"}
            />
          </div>
        );

        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={coupon.couponDetailId + ""}
              checked={coupon.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          couponName: coupon.couponName,
          couponCode: coupon.couponCode,
          startDate: moment(coupon.startDate).format("DD/MM/YYYY"),
          endDate: moment(coupon.endDate).format("DD/MM/YYYY"),
          status: status,
          actions: actions,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.couponDetailData !== nextprops.couponDetailData) {
      const data = nextprops.couponDetailData || [];
      this.buildCouponDataTable(this.filterData(data));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filter !== this.state.filter) {
      const data = this.props.couponDetailData || [];
      this.buildCouponDataTable(this.filterData(data));
    }
  }

  filterData = (data) => {
    const { active, inactive, expired } = this.state.filter;

    const checkForExpired = (date) => {
      const currentDate = moment("00:00:00", "HH:mm:ss");
      return (
        (expired && moment(date) < currentDate) ||
        (!expired && moment(date) >= currentDate)
      );
    };

    return data.filter((c) => {
      if (active && c.status === 1 && checkForExpired(c.endDate)) {
        return true;
      }
      if (inactive && c.status === 0 && checkForExpired(c.endDate)) {
        return true;
      }
      return false;
    });
  };

  viewCoupon = (couponDetailData) => () => {
    this.props.onViewCoupon(couponDetailData);
  };

  deleteCoupon = (couponId) => async () => {
    const response = await confirmBox();
    if (response) {
      this.props.deleteCouponDetailByCouponDetailIdRequest(couponId);
    }
  };

  toggleFilterDropdownOpen = () => {
    this.setState(({ filterDropdownOpen }) => ({
      filterDropdownOpen: !filterDropdownOpen,
    }));
  };

  filterToggle = (state) => () => {
    this.setState((prevState) => ({
      filter: {
        ...prevState.filter,
        [state]: !prevState.filter[state],
      },
      filterDropdownOpen: false,
      filterChanged: true,
    }));
    setTimeout(
      () =>
        this.setState({
          filterChanged: false,
        }),
      100
    );
  };

  render() {
    const { active, inactive, expired } = this.state.filter;
    const data = {
      columns: columns,
      rows: this.state.couponRecords,
    };

    return (
      <React.Fragment>
        <div className="d-flex justify-content-end mt-2">
          <ButtonDropdown
            isOpen={this.state.filterDropdownOpen}
            toggle={(f) => f}
          >
            <DropdownToggle
              outline
              color="dark"
              caret
              onClick={this.toggleFilterDropdownOpen}
            >
              Filter
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem tag="div">
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={active}
                      onChange={this.filterToggle("active")}
                    />{" "}
                    Active
                  </Label>
                </FormGroup>
              </DropdownItem>
              <DropdownItem tag="div">
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={inactive}
                      onChange={this.filterToggle("inactive")}
                    />{" "}
                    Inactive
                  </Label>
                </FormGroup>
              </DropdownItem>
              <DropdownItem tag="div">
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={expired}
                      onChange={this.filterToggle("expired")}
                    />{" "}
                    Expired
                  </Label>
                </FormGroup>
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
        </div>
        {!this.state.filterChanged && <CustomDataTable data={data} />}
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  couponDetailData: makeCouponDetailSelectField("couponDetailData"),
});

const withConnect = connect(mapStatetoProps, {
  getCouponDetailListRequest,
  updateCouponDetailStatusByCouponDetailIdRequest,
  deleteCouponDetailByCouponDetailIdRequest,
});

export default compose(withConnect, withRouter)(CouponList);
